import type { CanRequest } from "@/hooks/use-user-permissions";

export const usersPagePermissions = "switch-user" as const satisfies CanRequest;

export const sharePagePermissions =
  "create-ref-link" as const satisfies CanRequest;

export const viewBillingAll = "view-billing-all" as const satisfies CanRequest;

export const createIngredientPagePermissions = {
  or: ["create-ingredients", "create-categories"],
} as const satisfies CanRequest;

export const editIngredientPagePermissions = {
  or: ["update-ingredients", "create-categories", "delete-ingredients"],
} as const satisfies CanRequest;

export const editIngredientsPagePermissions = {
  or: [createIngredientPagePermissions, editIngredientPagePermissions],
} as const satisfies CanRequest;

export const createTemplateIngredientPagePermissions = {
  or: [
    {
      and: ["create-ingredients", "create-template-ingredients"],
    },
    {
      and: ["create-categories", "create-template-categories"],
    },
  ],
} as const satisfies CanRequest;

export const editTemplateMealsPagePermissions = {
    or: [
      {
        and: ["create-meals", "create-template-meals"],
      },
      {
        and: [
          {
            or: ["get-template-meals", "get-all-meals"],
          },
          {
            and: [
              "delete-meals",
              {
                or: ["delete-template-meals", "delete-all-meals"],
              },
            ],
          },
        ],
      },
    ],
  } as const satisfies CanRequest;

export const templateMealsPagePermissions = {
    or: [
      "apply-templates",
      "get-template-meals",
      "get-all-meals",
      editTemplateMealsPagePermissions,
    ],
} as const satisfies CanRequest;
  
export const editTemplateIngredientPagePermissions = {
  or: [
    {
      and: [
        "update-ingredients",
        {
          or: ["update-template-ingredients", "update-all-ingredients"],
        },
      ],
    },
    {
      and: ["create-categories", "create-template-categories"],
    },
    {
      and: [
        "delete-ingredients",
        {
          or: ["delete-template-ingredients", "delete-all-ingredients"],
        },
      ],
    },
  ],
} as const satisfies CanRequest;

export const templatePagePermissions = {
  and: [
    "get-all-templates",
    {
      or: [
        "apply-templates",
        createTemplateIngredientPagePermissions,
        {
          and: ["get-all-ingredients", editTemplateIngredientPagePermissions],
        },
      ],
    },
  ],
} as const satisfies CanRequest;

export const createTemplatePagePermissions =
  "create-templates" as const satisfies CanRequest;

export const editTemplatesPagePermissions = {
  and: ["get-all-templates", { or: ["update-templates", "delete-templates"] }],
} as const satisfies CanRequest;

export const templatesPagePermissions = {
  or: [
    "get-all-templates",
    "remove-templates",
    createTemplatePagePermissions,
    editTemplatesPagePermissions,
    templatePagePermissions,
  ],
} as const satisfies CanRequest;

export const editNutritionPagePermissions = {
  or: ["delete-meals", templatesPagePermissions],
} as const satisfies CanRequest;
